export default "__VITE_ASSET__BntrTaU3__"